import { consultFormService } from '../_services'
import { indexedDB } from '../_helpers'

function newConsultSteps() {
  return Object.assign(
    {},
    {
      ClientDetails: {
        title: 'Client Details',
        visited: true,
        complete: false,
      },
      ContactDetails: {
        title: 'Contact Details',
        visited: false,
        complete: false,
      },
      FarmDetails: {
        title: 'Farm Details',
        visited: false,
        complete: false,
      },
      AnimalNumbers: {
        title: 'Animal Numbers',
        visited: false,
        complete: false,
        requiredFields: ['cows_wintered_incl_r2'],
      },
      HistoricProduction: {
        title: 'Historic Production',
        visited: false,
        complete: false,
      },
      MastitisMilkQuality: {
        title: 'Mastitis/Milk Quality',
        visited: false,
        complete: false,
        dependsOn: ['AnimalNumbers'],
      },
      ReproductionPlanning: {
        title: 'Reproduction Planning',
        visited: false,
        complete: false,
      },
      TraceElements: {
        title: 'Trace Elements',
        visited: false,
        complete: false,
      },
      WelfareMonitoring: {
        title: 'Welfare Discussion',
        visited: false,
        complete: false,
        dependsOn: ['AnimalNumbers'],
      },
      AnimalHealth: {
        title: 'Animal Health',
        visited: false,
        complete: false,
      },
      PreventiveHealthAndVacination: {
        title: 'Preventive Health And Vaccination',
        visited: false,
        complete: false,
      },
      YoungStock: {
        title: 'Young Stock',
        visited: false,
        complete: false,
      },
      Programmes: {
        title: 'Programs',
        visited: false,
        complete: false,
      },
      DrugAllocations: {
        title: 'Drug Allocations',
        visited: false,
        complete: false,
      },
      DrugCombinations: {
        title: 'Drug Combinations',
        visited: false,
        complete: false,
      },
      EmailNotifications: {
        title: 'Email Notifications',
        visited: false,
        complete: false,
      },
      Disclaimer: {
        title: 'Disclaimer Page',
        visited: false,
        complete: false,
        dependsOn: ['__all__'],
      },
    }
  )
}

const state = {
  version: '0.6.1',
  client: null,
  currentIndex: 0,
  consultSteps: newConsultSteps(),
  models: {},
  backendErrors: {},
  dbName: 'winter-consult',
  signed: false,
  endpoints: {
    get: '/clients/{client}/winter_consult/{season}',
    post: '/clients/{client}/winter_consult/{season}/save',
  },
}

const actions = {
  // TODO: completely remove saveConsultData and take all data fetching actions into current_consult.module.js
  saveConsultData({ commit, state }, { clientId, season }) {
    let endpoint = state.endpoints.post.replace('{client}', clientId).replace('{season}', season)

    return indexedDB.get(clientId, state.dbName).then((consultData) => {

      if (consultData == undefined) {
        return Promise.reject(new Error('Consult not found on IDB'))
      }
      return consultFormService.saveClientConsultData(consultData.models, endpoint).catch((error) => {
        // return dispatch('addBackendErrors', {clientId: state.client, errors: error.response.data})
        if (error.response.status == 400) {
          commit('addBackendErrors', error.response.data)
        }
        return Promise.reject(error)
      })
    })
  },
  saveConsultAllocations({ commit, state }, { clientId, season }) {
    return indexedDB.get(clientId, state.dbName).then((consultData) => {
      // load data into vuex so that we can update the DrugAllocations step to
      // disable re submiting the allocations.
      if (consultData == undefined) {
        return Promise.reject(new Error('Consult not found on IDB'))
      }
      commit('setModels', consultData.models)
      commit('resetConsultSteps', consultData.consultSteps)
      commit('updateStateFromIDB', consultData)
      return consultFormService.saveClientAllocationsData(clientId, season, consultData.models).catch((error) => {
        if (error.response.status == 400) {
          commit('addBackendErrors', error.response.data)
        }
        return Promise.reject(error)
      })
    })
  },
  getConsultData({ commit, dispatch, state }, { clientId, season }) {
    return indexedDB.get(state.client, state.dbName).then((consultState) => {
      if (consultState && consultState.version === state.version) {
        commit('setModels', consultState.models)
        commit('resetConsultSteps', consultState.consultSteps)
        commit('updateStateFromIDB', consultState)
      } else {
        let endpoint = state.endpoints.get.replace('{client}', clientId).replace('{season}', season)

        return consultFormService.getClientConsultData(endpoint).then(
          (models) => {
            commit('resetConsultSteps', newConsultSteps())
            commit('setModels', models)
            dispatch('backupState', { models })
          },
          (error) => {
            return Promise.reject(error)
          }
        )
      }
    })
  },

  deleteSectionBackendErrors({ commit }, sectionName) {
    commit('deleteSectionBackendErrors', sectionName)
  },

  getReadOnlyData({ commit, state }, consultParams) {
    let endpoint = state.endpoints.get
      .replace('{client}', consultParams.clientId)
      .replace('{season}', consultParams.season)
    return consultFormService.getClientConsultData(endpoint).then(
      (models) => {
        commit('setClient', consultParams.clientId)
        commit('resetConsultSteps', newConsultSteps())
        commit('setModels', models)
      },
      (error) => {
        return Promise.reject(error)
      }
    )
  },
}

const getters = {
  isFonterraClient: (state) => {
    return state.models.Misc ? state.models.Misc.is_fonterra_client : false
  },
  isFonterraFarm: (state) => (farmId) => {
    return state.models.Misc ? state.models.Misc.FONTERRA_FARMS.includes(farmId) : false
  },
  seasonStartYear: (state) => {
    if (state.models.Misc) {
      return state.models.Misc.season_start_year
    }
    return ''
  },
  currentClientName: (state) => (state.models.Misc || { consult_title: '' }).consult_title,
  isReadOnly: (state) => {
    if (state.models.Misc) {
      return state.models.Misc.consult_state == 'finished' || state.models.Misc.read_only
    }
    return false
  },
  drugs_allocated: (state) => state.models.DrugAllocations.drugs_allocated,
}

const mutations = {
  setConsultSignedAt(state, { value }) {
    state.models.Misc.signed_at = value ? new Date().toJSON() : null
  },

  addBackendErrors(state, errors) {
    state.backendErrors = errors
  },
  deleteSectionBackendErrors(state, sectionName) {
    state.backendErrors[sectionName] = null
  },
  updateOrCreateAllocation(state, [farmID, data, isFutureAllocation]) {
    let allocations = state.models['DrugAllocations'].drugs_allocated[farmID]

    let alloc = allocations.find(
      (alloc) =>
        alloc.drug_allocation_product == data.drug_allocation_product &&
        alloc.is_future_allocation == isFutureAllocation
    )

    if (alloc) {
      alloc.par_qty = data.par_qty
    } else if (data.par_qty > 0) {
      allocations.push(data)
    }
  },
  addContact(state, { contactData, contactType }) {
    contactData.clientcontact_set = []

    if (!contactData.id) {
      contactData.frontend_id = Object.keys(state.models.ContactDetails[contactType]).length + 1
    }

    let c = Object.assign({}, contactData)
    state.models.ContactDetails[contactType].push(c)
  },
  editContact(state, { contactData, contactType }) {
    let contacts = state.models.ContactDetails[contactType]

    let lookup = contactData.frontend_id ? 'frontend_id' : 'id'

    let contact = contacts.filter((c) => c[lookup] == contactData[lookup])

    if (contact) {
      Object.assign(contact[0], contactData)
    }
  },
  removeContact(state, { contact, contactType }) {
    let contacts = state.models.ContactDetails[contactType]
    let lookup = contact.frontend_id ? 'frontend_id' : 'id'

    state.models.ContactDetails[contactType] = contacts.filter((c) => c[lookup] != contact[lookup])
  },
  addRole(state, { contact, contactrole, contactType }) {
    let contacts = state.models.ContactDetails[contactType]

    let lookup = contact.frontend_id ? 'frontend_id' : 'id'

    let filteredContact = contacts.filter((c) => c[lookup] == contact[lookup])

    if (filteredContact.length > 0) {
      let frontend_id = filteredContact[0].clientcontact_set.length + 1

      let cr = Object.assign({ frontend_id: frontend_id }, contactrole)
      filteredContact[0].clientcontact_set.push(cr)
    }
  },
  editRole(state, { contact, contactrole, contactType }) {
    let contacts = state.models.ContactDetails[contactType]
    let lookup = contact.frontend_id ? 'frontend_id' : 'id'
    let filteredContact = contacts.filter((c) => c[lookup] == contact[lookup])

    if (filteredContact.length > 0) {
      let contactrole_lookup = contactrole.frontend_id ? 'frontend_id' : 'id'
      let filteredContactRole = filteredContact[0].clientcontact_set.filter(
        (cr) => cr[contactrole_lookup] == contactrole[contactrole_lookup]
      )

      if (filteredContactRole.length > 0) {
        Object.assign(filteredContactRole[0], contactrole)
      }
    }
  },
  addCombination(state, { combination, farm }) {
    state.models.DrugCombinations.combinations[farm.id].push({
      farm_label: farm.farm_label,
      product_1: combination.productid_1,
      product_2: combination.productid_2,
      product_3: combination.productid_3,
      drugname_1: combination.drugname_1,
      drugname_2: combination.drugname_2,
      drugname_3: combination.drugname_3,
      whp_text: combination.whp_text,
    })
  },
  removeCombination(state, { index, farmId }) {
    state.models.DrugCombinations.combinations[farmId].splice(index, 1)
  },
  updateCombination(state, { index, farmId, combination }) {
    state.models.DrugCombinations.combinations[farmId][index] = combination
  },
}

export default {
  stateMixin: state,
  actionsMixin: actions,
  mutationsMixin: mutations,
  gettersMixin: getters,
}
